import axios from 'axios';

import { errorCodeOf } from '../../../api/errors';
import { marketplaceErrorKey } from '../../../components/marketplace';

/**
 * Error `code` → i18n key for every «Компании» write (AUT-403). The writes
 * opt out of the shared auto-toast, so the caller shows exactly one toast
 * with this key. Codes are the `orgs` module's stable `DomainError` codes.
 *
 * A company made from a specialist's profile (`source: 'self'`, AUT-536)
 * refuses brand edits, the owner code and removing its owner with
 * `org_self_*` 409s — their texts live with the «Площадка» errors
 * (`marketplace.errors.*`), so the same code reads the same everywhere.
 */
const SELF_ORG_CODES = new Set([
  'org_self_brand_from_profile',
  'org_self_owner_fixed',
  'org_self_owner_remove_forbidden',
]);

const KNOWN_CODES = new Set([
  'org_not_found',
  'org_terminated',
  'org_unp_taken',
  'city_custom_invalid',
  'city_custom_refused',
  'city_unknown',
  'org_max_members_below_active',
  'org_member_not_found',
  'org_member_code_unavailable',
  'org_logo_key_invalid',
  'org_logo_not_uploaded',
  'org_logo_too_large',
  'org_logo_invalid',
]);

export const companyErrorKey = (err: unknown): string => {
  const code = errorCodeOf(err);
  if (code !== null && SELF_ORG_CODES.has(code)) return marketplaceErrorKey(err);
  if (code !== null && KNOWN_CODES.has(code)) return `companies.errors.${code}`;
  if (code?.startsWith('validation_')) return 'companies.errors.validation';
  if (axios.isAxiosError(err) && err.response?.status === 403) return 'errors.forbidden';
  return 'companies.errors.generic';
};
